export default __webpack_public_path__ + "img/4d1ea0f1e15b0ee938c4d3846cf2ea98.svg";